<template>
  <div class="UserCard">
    <mu-row justify-content="center" style="width:100%">
      <mu-avatar size="60">
        <img src="../../../../static/img/avatar.jpg">
      </mu-avatar>
    </mu-row>
    <div class="LoginOutBtn">
      <mu-button color="primary" small @click="Logout">退出</mu-button>
      <mu-button color="success" small @click="Refresh">刷新</mu-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserCard',
  methods: {
    Logout: function() {
      this.$emit('Logout')
    },
    Refresh: function() {
      this.$emit('Refresh')
    }
  }
}
</script>

<style scoped>
.UserCard{
  height: 130px;
  text-align: center;
  padding: 10px 0px;
  background-color:#ffffffd8;
}
.LoginOutBtn{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/Login/components/UserCard.vue